import { Modal, Button } from "../../../ui/index.ts";

export type SaveAssignedChangesConfirmModalProps = {
  open: boolean;
  projectName: string;
  inactiveEmployeeNames: string[];
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  saving?: boolean;
};

export function SaveAssignedChangesConfirmModal({
  open,
  projectName,
  inactiveEmployeeNames,
  onConfirm,
  onCancel,
  saving = false,
}: SaveAssignedChangesConfirmModalProps) {
  const hasInactive = inactiveEmployeeNames.length > 0;
  const list = inactiveEmployeeNames.join(", ");

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title="Save allocation changes?"
      footer={
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            gap: "0.75rem",
            width: "100%",
          }}
        >
          <Button
            type="button"
            variant="muted-outline"
            onClick={onCancel}
            disabled={saving}
          >
            {hasInactive ? "Go back" : "Cancel"}
          </Button>
          <Button type="button" onClick={() => void onConfirm()} disabled={saving}>
            {saving ? "Saving…" : hasInactive ? "Save anyway" : "Confirm"}
          </Button>
        </div>
      }
    >
      {hasInactive ? (
        <p className="body-sm" style={{ margin: 0, color: "var(--content-muted)" }}>
          For{" "}
          <strong className="sub-heading-sm" style={{ color: "var(--content)" }}>
            {projectName}
          </strong>
          , the following employees have 0 allocated hours and will be marked
          inactive:{" "}
          <strong className="sub-heading-sm" style={{ color: "var(--content)" }}>
            {list}
          </strong>
          . Do you want to continue or go back and assign hours?
        </p>
      ) : (
        <p className="body-sm" style={{ margin: 0, color: "var(--content-muted)" }}>
          This will save allocated hours for{" "}
          <strong className="sub-heading-sm" style={{ color: "var(--content)" }}>
            {projectName}
          </strong>{" "}
          to the server.
        </p>
      )}
    </Modal>
  );
}
